<template>
  <div class="container" id="top-page">
    <v-expansion-panels multiple v-model="panel">
      <v-expansion-panel>
        <v-expansion-panel-header class="Header"
          >Project Jobs Management</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search1"
          />
          <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate1" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate1" class="input_date" />
            </div>
          </div>
          <br />
          <v-data-table
            v-if="headerItemsFilterDate.length <= 0"
            item-key="name"
            class="elevation-1 table-header"
            loading
            :items-per-page="5"
            hide-default-footer
            :headers="headersNotfound"
            :items="itemNotfound"
            loading-text="Loading... Please wait"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              />
            </template>
          </v-data-table>
          <v-data-table
            v-else
            :items-per-page="5"
            :headers="pjobHeader"
            :items="headerItemsFilterDate"
            hide-default-footer
            class="elevation-1 table-header"
            @click:row="handleRowClick"
          >
            <template v-slot:top="{ pagination, options, updateOptions }">
              <v-data-footer
                :pagination="pagination"
                :options="options"
                @update:options="updateOptions"
                items-per-page-text="$vuetify.dataTable.itemsPerPageText"
              />
              <v-dialog v-model="dialog" max-width="750px">
                <v-card>
                  <v-card-title>
                    <span class="text-h5">Job Information</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <div v-for="(header, idx) in pjobHeader" :key="idx">
                          <v-col cols="auto" sm="auto" md="auto">
                            <v-text-field
                              color="black"
                              v-if="checkIsEmpty(curPJob[header.value])"
                              v-model="emptyItem"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                            <v-text-field
                              color="black"
                              v-else
                              v-model="curPJob[header.value]"
                              :label="header.text"
                              :readonly="true"
                            ></v-text-field>
                          </v-col>
                        </div>
                      </v-row>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-btn color="blue darken-1" text @click="close">
                      OK
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="seeDetail">
                      See Job Details
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </template>
            <template
              v-for="header in pjobHeader"
              v-slot:[`item.${header.value}`]="{ item }"
            >
              <template v-if="isBoolean(item[header.value])">
                <div class="checkbox_container" v-bind:key="item[header.value]">
                  <v-checkbox
                    v-bind:key="item[header.value]"
                    v-model="item[header.value]"
                    :true-value="true"
                    :false-value="false"
                    light
                    disabled
                    color="black"
                  ></v-checkbox>
                </div>
              </template>
              <template v-else>
                {{ item[header.value] }}
              </template>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel id="detail" style="margin-top: 30px">
        <v-expansion-panel-header class="Header"
          >Project Job Details</v-expansion-panel-header
        >
        <v-expansion-panel-content>
          <h4 style="font-weight: bold">Search:</h4>
          <input
            class="form-control border input-search"
            id="myInput"
            type="text"
            v-model="search2"
          />
          <!-- <div class="filter_date">
            <div class="filter_date_item">
              <h4>From Date:</h4>
              <input type="date" v-model="fromdate2" class="input_date" />
            </div>
            <div class="filter_date_item ml-20">
              <h4>To Date:</h4>
              <input type="date" v-model="todate2" class="input_date" />
            </div>
          </div> -->
          <br />
          <tableComponent
            :tableHeaders="pjobDetail"
            :tableItems="detailItemsFilterDate"
          >
          </tableComponent>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import tableComponent from "../table/tableComponent.vue";
import { mapGetters } from "vuex";
import DecodeJWT from "../DecodeJWT";

export default {
  components: { tableComponent },
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
      } else {
        window.scrollTo({
          top: document.getElementById("top-page").offsetTop,
          left: 0,
          behavior: "smooth",
        });
        this.panel = Array.from(Array(2).keys());
        this.getBAQProjectJobs();
        const today = new Date();
        const fromday = new Date();
        fromday.setMonth(fromday.getMonth() - 3);
        let year = today.getFullYear();
        let month = (today.getMonth() + 1).toString().padStart(2, "0");
        let day = today.getDate().toString().padStart(2, "0");
        this.todate1 = this.todate2 = `${year}-${month}-${day}`;
        year = fromday.getFullYear();
        month = (fromday.getMonth() + 1).toString().padStart(2, "0");
        day = fromday.getDate().toString().padStart(2, "0");
        this.fromdate1 = this.fromdate2 = `${year}-${month}-${day}`;
      }
    }
  },
  data() {
    return {
      headersNotfound: [{ text: "", value: "nf" }],
      itemNotfound: [{ nf: "Data not found!" }],
      pjobHeader: [
        { text: "Project ID", value: "Project_ProjectID" },
        { text: "Description", value: "Project_Description" },
        { text: "Active", value: "Project_ActiveProject" },
        { text: "Start Date", value: "Project_StartDate" },
        { text: "End Date", value: "Project_EndDate" },
        { text: "Closed Date", value: "Project_ClosedDate" },
        { text: "Revision", value: "Project_Revision" },
        { text: "Contract ID", value: "Project_ContractID" },
      ],
      pjobDetail: [
        { text: "Project Phase", value: "ProjPhase_PhaseID" },
        { text: "Description", value: "ProjPhase_Description" },
        { text: "Phase Status", value: "ProjPhase_PhaseStatus" },
        { text: "Percent Complete", value: "ProjPhase_PercentComplete" },
        { text: "Start Date", value: "ProjPhase_StartDate" },
        { text: "Due Date", value: "ProjPhase_DueDate" },
        { text: "Date Complete", value: "ProjPhase_DateComplete" },
        { text: "Duration", value: "ProjPhase_Duration" },
        { text: "WBSJobNum", value: "ProjPhase_WBSJobNum" },
      ],
      headerItems: [],
      detailItems: [],
      panel: [],
      dialog: false,
      curPJob: {},
      search1: "",
      search2: "",
      fromdate1: "",
      todate1: "",
      fromdate2: "",
      todate2: "",
      emptyItem: " ",
    };
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];

      setTimeout(() => (this[l] = false), 3000);

      this.loader = null;
    },
    getProjectJobs() {
      this.loadHeader();
    },
    getProjectJobsDtls() {
      this.loadDetail();
    },
  },
  computed: {
    ...mapGetters("User", ["getUserInfo"]),
    ...mapGetters("Data", ["getProjectJobs", "getProjectJobsDtls"]),
    headerItemsFilter() {
      const filterKey = (this.search1 || "").toLowerCase();
      if (this.headerItems == null || filterKey === "") return this.headerItems;
      return this.headerItems.filter((i) => {
        return (
          i.Project_ProjectID.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.Project_Description.toString().toLowerCase().indexOf(filterKey) > -1
        );
      });
    },
    headerItemsFilterDate() {
      if (this.headerItemsFilter.length > 0) {
        let from = new Date(this.fromdate1);
        let to = new Date(this.todate1);
        return this.headerItemsFilter.filter((i) => {
          let day = i.Project_StartDate.split("/")[0];
          let month = i.Project_StartDate.split("/")[1];
          let year = i.Project_StartDate.split("/")[2];
          let date = new Date(year, month - 1, day);
          return date <= to && from <= date;
        });
        // return this.headerItemsFilter;
      } else {
        return this.headerItemsFilter;
      }
    },
    detailItemsFilter() {
      const filterKey = (this.search2 || "").toLowerCase();
      if (this.detailItems == null || filterKey === "") return this.detailItems;
      return this.detailItems.filter((i) => {
        return (
          i.ProjPhase_PhaseID.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.ProjPhase_Description.toString().toLowerCase().indexOf(filterKey) >
            -1 ||
          i.ProjPhase_PhaseStatus.toString().toLowerCase().indexOf(filterKey) >
            -1
        );
      });
    },
    detailItemsFilterDate() {
      if (this.detailItemsFilter.length > 0) {
        // let from = new Date(this.fromdate2);
        // let to = new Date(this.todate2)
        // return this.detailItemsFilter.filter((i) => {
        //   let day = i.ProjPhase_StartDate.split('/')[0];
        //   let month = i.ProjPhase_StartDate.split('/')[1];
        //   let year = i.ProjPhase_StartDate.split('/')[2];
        //   let date = new Date(year, month-1, day);
        //   return date <= to && from <= date;
        // });
        return this.detailItemsFilter;
      } else {
        return this.detailItemsFilter;
      }
    },
  },
  methods: {
    close() {
      this.dialog = false;
    },
    checkIsEmpty(value) {
      if (typeof value === "string") {
        if (value.length == 0) return true;
        return false;
      }
      if (typeof value === "boolean") {
        return false;
      }
      return false;
    },
    seeDetail() {
      this.dialog = false;
      this.getBAQPJobDetail(this.curPJob);
      window.scrollTo({
        top: document.getElementById("detail").offsetTop,
        left: 0,
        behavior: "smooth",
      });
    },
    isBoolean(value) {
      return typeof value === "boolean";
    },
    handleRowClick(item) {
      this.curPJob = item;
      this.dialog = true;
    },
    convertDate(stringdate) {
      if (stringdate) {
        var dateObject = new Date(stringdate);
        var day = dateObject.getDate().toString().padStart(2, "0");
        var month = (dateObject.getMonth() + 1).toString().padStart(2, "0");
        var year = dateObject.getFullYear();
        return `${day}/${month}/${year}`;
      } else return "";
    },
    convertDate2(stringdate) {
      //thang/ngay/YY
      var dateObject = new Date(stringdate);
      var day = dateObject.getDate();
      var month = dateObject.getMonth() + 1;
      var year = dateObject.getFullYear();
      return `${day}/${month}/${year}`;
    },
    async getBAQProjectJobs() {
      await this.$store.dispatch("Data/getProjectJobHeadData");
      this.loadHeader();
    },
    async getBAQPJobDetail(item) {
      await this.$store.dispatch("Data/getProjectJobDtlData", {
        id: item.Project_ProjectID,
      });
      this.loadDetail();
    },
    loadHeader() {
      this.headerItems = [];
      if (this.getProjectJobs && this.getProjectJobs.length > 0) {
        this.getProjectJobs.forEach((el) => {
          this.headerItems.push({
            Project_ProjectID: el.Project_ProjectID,
            Project_Description: el.Project_Description,
            Project_ActiveProject: el.Project_ActiveProject,
            Project_StartDate: this.convertDate(el.Project_StartDate),
            Project_EndDate: this.convertDate(el.Project_EndDate),
            Project_ClosedDate: this.convertDate(el.Project_ClosedDate),
            Project_Revision: el.Project_Revision,
            Project_ContractID: el.Project_ContractID,
          });
        });
      }
    },
    loadDetail() {
      this.detailItems = [];
      if (this.getProjectJobsDtls && this.getProjectJobsDtls.length > 0) {
        this.getProjectJobsDtls.forEach((el) => {
          this.detailItems.push({
            ProjPhase_PhaseID: el.ProjPhase_PhaseID,
            ProjPhase_Description: el.ProjPhase_Description,
            ProjPhase_PhaseStatus: el.ProjPhase_PhaseStatus,
            ProjPhase_PercentComplete: el.ProjPhase_PercentComplete,
            ProjPhase_StartDate: this.convertDate(el.ProjPhase_StartDate),
            ProjPhase_DueDate: this.convertDate(el.ProjPhase_DueDate),
            ProjPhase_DateComplete: this.convertDate(el.ProjPhase_DateComplete),
            ProjPhase_Duration: el.ProjPhase_Duration,
            ProjPhase_WBSJobNum: el.ProjPhase_WBSJobNum,
          });
        });
      }
    },
  },
};
</script>

<style scoped>
.table td {
  white-space: nowrap;
  text-overflow: ellipsis;
}
.ml-20 {
  margin-left: 100px;
}
.input_date {
  outline: #d1dfe3;
}
.filter_date {
  display: flex;
  flex-direction: row;
}
.filter_date_item {
  display: flex;
  flex-direction: column;
}
.mb-20 {
  margin-bottom: 50px;
}
.Header {
  font-weight: 700;
  font-size: 1.2em;
  color: white;
  background-color: #d1dfe3;
  color: black;
}
.table-custom {
  width: 100%;
  margin-top: 20px;
}

table,
th,
td {
  border: 1px solid #ddd;
  height: 50px;
  border-collapse: collapse;
}
th {
  border-bottom: 2px solid black;
}
td {
  text-align: center;
}
.input-search {
  margin-top: 5px;
  margin-bottom: 10px;
  outline: #d1dfe3;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #ddd;
}
.hidden {
  display: none !important;
}

a:hover {
  font-weight: bolder;
}

.switchTabMsg {
  text-align: center;
  width: fit-content;
  color: black !important;
  text-decoration: underline;
}

.passwordRules {
  margin-top: -25px;
  margin-left: 15px;
  font-size: small;
  opacity: 0.6;
}
.v-label .v-label--active .v-label--is-disabled .theme--light,
.v-application--is-ltr .v-text-field .v-label {
  transform-origin: top left;
  color: black !important;
}
</style>
